import { baseApi } from './baseApi'

export type RetellOutboundCallWindow = {
  start: string
  end: string
}

export type TransferLimitRule = {
  id: string
  label?: string
  buckets: string[]
  maxTransfers: number
  windowMinutes: number
}

export type ResourceMappingResourceView = {
  id: string
  label: string
  days: string
  hours: string
  timezone: string
}

export type ResourceMappingView = {
  bucket: string
  callReason: string
  resources: ResourceMappingResourceView[]
}

export type RetellOutboundSettings = {
  id: string
  useCase: string
  displayName: string
  scopeType: 'GLOBAL' | 'OFFICE'
  scopeId: string
  enabled: boolean
  dryRun: boolean
  paused: boolean
  outboundAgentId: string | null
  fromNumber: string | null
  defaultTimezone: string
  weekendsEnabled: boolean
  officeHours: RetellOutboundCallWindow
  patientContactHours: RetellOutboundCallWindow
  maxCallsPerDay: number | null
  maxCallsPerOfficePerHour: number | null
  transferLimitRules: TransferLimitRule[]
  concurrencyRetrySeconds: number
  testCallEnabled: boolean
  featureEnabled: boolean
  resourceMappings: ResourceMappingView[]
}

export type PlaceRetellOutboundTestCallRequest = {
  orderId: number
  bucket?: string | null
  toNumberOverride?: string | null
}

export type PlaceRetellOutboundTestCallResult = {
  attemptId: string
  retellCallId: string | null
  toNumber: string
  bucket: string
}

export const retellOutboundSettingsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getRetellOutboundSettings: builder.query<RetellOutboundSettings, void>({
      query: () => ({ url: '/lab/settings/retell-outbound' }),
      providesTags: ['RetellOutboundSettings'],
    }),
    updateRetellOutboundSettings: builder.mutation<
      RetellOutboundSettings,
      Partial<RetellOutboundSettings>
    >({
      query: (body) => ({
        url: '/lab/settings/retell-outbound',
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['RetellOutboundSettings'],
    }),
    placeRetellOutboundTestCall: builder.mutation<
      PlaceRetellOutboundTestCallResult,
      PlaceRetellOutboundTestCallRequest
    >({
      query: (body) => ({
        url: '/lab/settings/retell-outbound/test-call',
        method: 'POST',
        body,
      }),
    }),
  }),
})

export const {
  useGetRetellOutboundSettingsQuery,
  useUpdateRetellOutboundSettingsMutation,
  usePlaceRetellOutboundTestCallMutation,
} = retellOutboundSettingsApi
